import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-koscheres-essen',
  templateUrl: './koscheres-essen.component.html',
  styleUrls: ['./../app.component.css']
})
export class KoscheresEssenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
